export default __webpack_public_path__ + "static/media/about-mission.9fff117b.png";